module.exports = __webpack_public_path__ + "static/answer_btn-8abb6bfb9e976fe623339fadd627d1ed.png";